import { render, staticRenderFns } from "./centers-infos.vue?vue&type=template&id=7f046c46&scoped=true"
import script from "./centers-infos.vue?vue&type=script&lang=js"
export * from "./centers-infos.vue?vue&type=script&lang=js"
import style0 from "./centers-infos.vue?vue&type=style&index=0&id=7f046c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f046c46",
  null
  
)

export default component.exports